<template>
  <div v-if="showCrediExpert" id="credi-experto" class="card-item mt-6">
    <h3 class="title is-5 has-text-primary">Sua executiva</h3>
    <div class="avatar avatar-xxl profile-cover-avatar" for="avatar_upload">
      <img class="avatar-img" :src="crediExpert.photo" :alt="crediExpert.name">
    </div>
    <p class="avatar-name">{{ crediExpert.name }}</p>
    <div class="is-centered has-text-centered">
      <a
        id="credi-experto-whatsapp"
        class="expert-data"
        href="#credi-experto-whatsapp"
        @click="clickEvent(
          `https://wa.me/+${crediExpert.phone}?texto=Ol%C3%A1%2C%20preciso%20da%20sua%20ajuda.`,
          'whatsapp')">
        <span class="expert-icon"><i class="fa-brands fa-whatsapp fa-bounce" /></span> +{{ crediExpert.phone }}</a>
      <a
        id="credi-experto-email"
        class="expert-data"
        href="#credi-experto-email"
        @click="clickEvent(
          `mailto:${crediExpert.email}?subject=Ol%C3%A1%2C%20preciso%20da%20sua%20ajuda.`,
          'email'
        )">
        <span class="expert-icon"><i class="fa-solid fa-envelope fa-bounce" /></span> {{ crediExpert.email }}</a>
    </div>
  </div>
</template>
<script>
import { publish } from 'creditu-events-lib';
import { CrediExperto } from '@/application/services/credi-experto';
import { getFeatureToggleByName } from '@/application/services/api-clients/features-toggles';
import { CrediExpertoContactLinkClicked } from '@/domain/events/credi-experto-contact-link.clicked';
import { CrediExpertoShowed } from '@/domain/events/credi-experto-showed';
import notification from '@/ui/mixins/notification';

export default {
  name: 'CrediExperto',
  mixins: [notification],
  data() {
    return {
      showCrediExpert: false,
      crediExpert: {
        name: 'Mari da Creditú',
        phone: '551128530616',
        email: 'mari@creditu.com',
        photo: 'https://s3.amazonaws.com/assets.cdtu.cl/credi-experto/credi-experto-default-br.jpg'
      }
    };
  },
  async mounted() {
    this.creditExpert();
  },
  methods: {
    async creditExpert() {
      try {
        const crediExperto = new CrediExperto(getFeatureToggleByName);
        this.showCrediExpert = await crediExperto.showCrediExperto();
        this.crediExpertoShowed('simulador');
        // eslint-disable-next-line no-empty
      } catch (_e) {
      }
    },
    async crediExpertoShowed(place) {
      try {
        await publish(new CrediExpertoShowed(
          { prospectId: this.prospectId, place },
          { country: this.$i18n.locale, origin: 'INTERNAL-FRONTEND' }
        ));
        // eslint-disable-next-line no-empty
      } catch (_e) { }
    },
    async clickEvent(url, type) {
      try {
        await publish(new CrediExpertoContactLinkClicked(
          { prospectId: this.prospectId, type },
          { country: this.$i18n.locale, origin: 'INTERNAL-FRONTEND' }
        ));
        // eslint-disable-next-line no-empty
      } catch (_e) { }
      window.open(url, '_self');
    }
  }

};
</script>
<style lang="css">
.avatar {
  position: relative;
  display: inline-block;
  width: 3rem;
  height: 3rem
}
.avatar > img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}
.avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}
.card-item.mt-6 {
  text-align: center;
}
.profile-cover-avatar .avatar-img {
  display: block;
  max-width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  pointer-events: none;
  border-radius: 50%;
}
.profile-cover-avatar {
  display: -ms-flexbox;
  display: flex;
  margin: 0 auto .5rem auto;
  border: 3px solid #fff;
  border-radius: 50%;
}
@media (min-width: 768px) {
  .avatar-xxl {
    width: 8rem;
    height: 8rem;
  }
}
.avatar-name {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#333;
  font-weight:bold;
  font-size: 1.4rem;
  line-height:1;
}

.avatar-rol {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#666;
}
.expert-data{
  display: inline-block;
  margin: 5px;text-align: center;
}
</style>
